import { rest } from 'msw';
import {
  existedHostname,
  exceptionCausingName,
  existedEmail,
  testInstanceUrl,
  triggerCompleteSignup409,
  registrationIdForHappyPath,
  registrationIdForPollingTimeout,
  pollingTimeoutCausingName,
  invalidPassword,
} from './constants';

export const handlers = [
  rest.post('/xm/free/api/registration', (req, res, ctx) => {
    if (req.body.firstName === exceptionCausingName) {
      return res(ctx.status(500));
    }

    if (req.body.email === existedEmail) {
      return res(ctx.status(409));
    }

    const registrationId =
      req.body.firstName === pollingTimeoutCausingName
        ? registrationIdForPollingTimeout
        : registrationIdForHappyPath;

    return res((res) => {
      res.headers.set(
        'Location',
        `/xm/free/api/registration/${registrationId}`,
      );
      res.status = 201;
      return res;
    });
  }),

  rest.head(`/xm/free/api/availability/:hostname`, (req, res, ctx) => {
    const { hostname } = req.params;
    if (hostname === existedHostname) {
      return res(ctx.status(204));
    }

    if (hostname === exceptionCausingName) {
      return res(ctx.status(503));
    }

    if (/^[A-Za-z0-9]+(-[A-Za-z0-9]+)*$/.test(hostname)) {
      return res(ctx.status(200));
    }

    return res(ctx.status(400));
  }),

  rest.post('/xm/free/api/registration/:registrationId', (req, res, ctx) => {
    if (req.body.password === exceptionCausingName) {
      return res(ctx.status(503));
    }

    if (req.body.hostnamePrefix === triggerCompleteSignup409) {
      return res(ctx.status(409));
    }

    return res(ctx.status(202));
  }),

  rest.get('/xm/free/api/registration/:registrationId', (req, res, ctx) => {
    const registrationId = req.params.registrationId;
    const status =
      registrationId === registrationIdForHappyPath
        ? 'PROVISIONED'
        : 'ACCEPTED_FOR_PROVISIONING';
    const redirectURL =
      registrationId === registrationIdForHappyPath ? testInstanceUrl : '';
    return res(
      ctx.status(200),
      ctx.json({
        status,
        redirectURL,
      }),
    );
  }),

  rest.get(`${testInstanceUrl}/ping`, (req, res, ctx) => {
    return res(ctx.status(200));
  }),

  rest.post('/xm/free/api/password/validate', (req, res, ctx) => {
    if (req.body.password === invalidPassword) {
      return res(
        ctx.status(200),
        ctx.json({
          dictionaryMatchingPassed: true,
          noLeadingOrTrailingSpacesPassed: false,
          passwordMaximumLengthPassed: true,
          passwordMinimumLengthPassed: true,
          requiresLowercaseLetterPassed: true,
          requiresSpecialCharacterPassed: true,
          requiresUppercaseLetterPassed: false,
        }),
      );
    }
    return res(
      ctx.status(200),
      ctx.json({
        dictionaryMatchingPassed: true,
        noLeadingOrTrailingSpacesPassed: true,
        passwordMinimumLengthPassed: true,
        passwordMaximumLengthPassed: true,
        requiresUppercaseLetterPassed: true,
        requiresLowercaseLetterPassed: true,
        requiresSpecialCharacterPassed: true,
      }),
    );
  }),

  rest.get('/xm/free/api/password/policy', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        dictionaryMatching: true,
        passwordMinimumLength: 8,
        requiresUppercaseLetter: true,
        requiresLowercaseLetter: true,
        requiresSpecialCharacter: true,
        noLeadingOrTrailingSpaces: true,
        passwordMaximumLength: 100,
      }),
    );
  }),
];
